// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_iconeAdd__riVIp {
  color: #fff;
  font-size: 2rem;
}

.styles_iconeAdd__riVIp:hover {
  color: #18316e;
}

.styles_containerButtons__L7Ijj {
  align-items: center;
  display: flex;
  justify-content: space-between;
  margin-top: 1rem;
}

.styles_btnAdd__t1lG2 {
  border-radius: 50px !important;
  border-color: #18316e !important;
  color: #18316e !important;
  &:hover {
    border-color: #18316e !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/PreviaINSS/ModalAnalisar/StepsAnalisar/Impostos/styles.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,gCAAgC;EAChC,yBAAyB;EACzB;IACE,gCAAgC;EAClC;AACF","sourcesContent":[".iconeAdd {\n  color: #fff;\n  font-size: 2rem;\n}\n\n.iconeAdd:hover {\n  color: #18316e;\n}\n\n.containerButtons {\n  align-items: center;\n  display: flex;\n  justify-content: space-between;\n  margin-top: 1rem;\n}\n\n.btnAdd {\n  border-radius: 50px !important;\n  border-color: #18316e !important;\n  color: #18316e !important;\n  &:hover {\n    border-color: #18316e !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"iconeAdd": `styles_iconeAdd__riVIp`,
	"containerButtons": `styles_containerButtons__L7Ijj`,
	"btnAdd": `styles_btnAdd__t1lG2`
};
export default ___CSS_LOADER_EXPORT___;
